var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRepoStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.52002,
    y: 6.27734,
    width: 16.9114,
    height: 12.2814,
    fill: "#1E54A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92779 0.331985L6.46662 0.307617L4.0542 5.30305H8.09928L8.92779 0.331985Z",
    fill: "#EDF3F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46666 0.307617H3.73745L0.204102 5.30305H4.05424L6.46666 0.307617Z",
    fill: "#E4C342"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1209 0.332031H13.5577L15.9458 5.30309H11.9007L11.1209 0.332031Z",
    fill: "#EDF3F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5577 0.332031H16.2869L19.7959 5.30309H15.9458L13.5577 0.332031Z",
    fill: "#E4C342"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0966 0.332031H8.92788L8.09937 5.30309H11.9008L11.0966 0.332031Z",
    fill: "#E4C342"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.204102 5.30273H4.05424V7.17907C4.05424 8.24225 3.19236 9.10414 2.12917 9.10414C1.06598 9.10414 0.204102 8.24225 0.204102 7.17907V5.30273Z",
    fill: "#E2A431"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9458 5.30273H19.7959V7.17907C19.7959 8.24225 18.9341 9.10414 17.8709 9.10414C16.8077 9.10414 15.9458 8.24225 15.9458 7.17907V5.30273Z",
    fill: "#E2A431"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0542 5.30273H8.09928V7.08159C8.09928 8.19861 7.19376 9.10414 6.07674 9.10414C4.95972 9.10414 4.0542 8.19861 4.0542 7.08159V5.30273Z",
    fill: "#DAE4ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9006 5.30273H15.9457V7.08159C15.9457 8.19861 15.0402 9.10414 13.9232 9.10414C12.8062 9.10414 11.9006 8.19861 11.9006 7.08159V5.30273Z",
    fill: "#DAE4ED"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09937 5.30273H11.9008V7.20343C11.9008 8.25316 11.0498 9.10414 10.0001 9.10414C8.95034 9.10414 8.09937 8.25316 8.09937 7.20344V5.30273Z",
    fill: "#E2A431"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.93226,
    y: 10.3471,
    width: 5.65337,
    height: 4.72738,
    fill: "#EDF3F9",
    stroke: "#E29B2D",
    strokeWidth: 0.633567
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.983887,
    y: 18.5596,
    width: 17.8373,
    height: 1.2184,
    fill: "#E2A431"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7058,
    y: 10.0303,
    width: 4.97106,
    height: 8.52878,
    fill: "#E29B2D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2419,
    y: 10.7617,
    width: 3.89887,
    height: 2.68047,
    fill: "#EDF3F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2419,
    y: 14.0264,
    width: 3.89887,
    height: 4.53244,
    fill: "#EDF3F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRepoStore);
export default __webpack_public_path__ + "static/media/ic-repo-store.1f18c737aec0cb7ee41d9002d6f07c89.svg";
export { ForwardRef as ReactComponent };